import { observer } from "mobx-react-lite";
import { useCallback, useEffect } from "react";

import { useParameters } from "../store";
import { getDefaultModel } from "../utils";

import { EditParameters } from "./EditParameters";

import { useModelsStore } from "@/providers/ProviderAndModelsProvider/models-store";

export const ParametersContent = observer(
  ({ shouldShowClearButton = true }: { shouldShowClearButton?: boolean }) => {
    const store = useParameters();
    const { store: modelsStore } = useModelsStore({});
    const { modelsLoading } = modelsStore;

    const setDefaultParameters = useCallback(() => {
      const defaultModel = getDefaultModel(store.models || [], store.isPromptChat);

      store.updateModel(defaultModel);
    }, [store]);

    useEffect(() => {
      if (!store.modelName && !store.provider) {
        setDefaultParameters();
      }
    }, [setDefaultParameters, store.modelName, store.provider, modelsLoading]);

    return <EditParameters shouldShowClearButton={shouldShowClearButton} />;
  },
);
